import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const StickyHeader = ({ isVisible, setIsVisible }) => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const dismissed = localStorage.getItem("stickyHeaderDismissed");
        if (dismissed === "true") {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
        // const handleScroll = () => {
        //     const currentScrollY = window.scrollY;
        //     setScrollY(currentScrollY);
        //     console.log(scrollY, "scroll", currentScrollY)
        //     if (currentScrollY > 100 && isVisible) {
        //         setIsVisible(false);
        //     }
        // };
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > 100) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
            setScrollY(currentScrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const closeBanner = () => {
        setIsVisible(false);
        localStorage.setItem("stickyHeaderDismissed", "true");
    };

    return (
        isVisible && (
            <div className="sticky-header text-white d-flex align-items-center justify-content-between py-1 px-1 container-fluid"
                style={{ backgroundColor: "#6A0DAD" }}>
                <span className="fw-bold text-center flex-grow-1">
                    📱 Get Instant Audition Alerts! 📢 Download the Hyderabad Casting Club App now 🔔🎭
                </span>
                <div>
                    <a href="https://play.google.com/store/apps/details?id=com.hyderabadcastingclub.android"
                        className="btn btn-light fw-bold btn-sm mx-2">Download Now</a>
                    <button onClick={closeBanner} className="btn btn-outline-dark btn-sm">❌</button>
                </div>
            </div>
        )
    );
};

export default StickyHeader;